module.exports = __webpack_public_path__ + "static/img/Space_exploration_Heroimage.f140dac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Space_exploration_Heroimage.jpg
// module id = ejgo
// module chunks = 0